import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const DeviceIdsStyled = styled.div`
  .deviceIds {
    &__fileUpload {
      border-radius: 6px;
      background: ${props => props.theme.uiColors.deviceTargetingBackground};
      padding: 16px;
      width: 100%;
      
      &__description {
        display: inline-flex;
        justify-content: center;
        width: 100%;
        gap: 5px;
        color: ${props => props.theme.uiColors.textBodyDefault};
        font-family: ${props => props.theme.fontRegular};
        font-size: ${props => props.theme.fontSizeS};

        > span {
          font-family: ${props => props.theme.fontBold};
          color: ${props => props.theme.uiColors.textTitle};
        }
      }

      &__confirmed {
        font-size: ${props => props.theme.fontSizeXS};
        height: 46px;
        line-height: 16px;
        color: ${props => props.theme.uiColors.deviceTargetingLoadingText};
        background: ${props => props.theme.uiColors.background07};
        width: 100%;
        border: 1px solid ${props => props.theme.uiColors.tableBorderRow};
        border-radius: 4px;
        display: inline-flex;
        gap: 8px;
        align-items: center;
        font-family: ${props => props.theme.fontSemiBold};
        text-wrap: nowrap;
        padding: 12px 16px;

        &Delete {
          justify-content: end;
        }

        &Spinner {
          padding: 5px;
          background: ${props => props.theme.uiColors.boxBgColor02};
          border-radius: 50%;
        }

        &Icon {
          padding: 5px;
          background: ${props => props.theme.uiColors.deviceTargetingConfirmIcon};
          border-radius: 50%;
        }

        &Name {
          color: ${props => props.theme.uiColors.textBodyDefault};
          width: 100%;
          ${mixins.ellipsis};
        }
      }
      
      &__templateButton {
        display: inline-flex;
        width: 136px;
        margin: 33px calc(50% - 68px);
      }
      
      &__table {
        color: ${props => props.theme.uiColors.textBodyDefault};
        font-family: ${props => props.theme.fontRegular};
        font-size: ${props => props.theme.fontSizeS};
        border: 1px solid ${props => props.theme.uiColors.tableRowDisabled};
        border-radius: 6px;
        justify-self: center;

        & tr {
          & th {
            background: ${props => props.theme.uiColors.multiFlightBackground01};
            font-family: ${props => props.theme.fontBold};
            color: ${props => props.theme.uiColors.textTitle};
            padding: 8px;
            text-align: start;
          }
  
          & td {
            background: transparent;
            padding: 8px;
            border-top: 1px solid ${props => props.theme.uiColors.tableRowDisabled};
            font-size: ${props => props.theme.fontSizeXS};
          }
        }
      }

      &__button {
        display: inline-flex;
        margin: 25px calc(50% - 128px);
        width: 256px;
      }
    }
  }
`;
